<template>
  <footer id="footer">
    <section>
      <h2>About</h2>
      <p>
        This is a simple tool that allows you to generate donation badges for
        your projects and use in Markdown documents, web pages, and more. It is
        completely <b>free</b>.
      </p>
      <ul class="actions">
        <li><a href="#" class="button">Learn More</a></li>
      </ul>
    </section>
    <section>
      <h2>Contact</h2>
      <dl class="alt">
        <dt>Website</dt>
        <dd>
          <a href="https://arash-hatami.ir" target="_blank"
            >https://arash-hatami.ir</a
          >
        </dd>
        <dt>Email</dt>
        <dd><a href="mailto:me@arash-hatami.ir">me@arash-hatami.ir</a></dd>
      </dl>
      <ul class="icons">
        <li>
          <a
            href="https://twitter.com/hatamiarash7"
            target="_blank"
            class="icon brands fa-twitter alt"
            ><span class="label">Twitter</span></a
          >
        </li>
        <li>
          <a
            href="https://www.instagram.com/hatamiarash7/"
            class="icon brands fa-instagram alt"
            target="_blank"
            ><span class="label">Instagram</span></a
          >
        </li>
        <li>
          <a
            href="https://github.com/hatamiarash7/"
            class="icon brands fa-github alt"
            target="_blank"
            ><span class="label">GitHub</span></a
          >
        </li>
        <li>
          <a
            href="https://stackoverflow.com/users/4905220/arash-hatami"
            class="icon brands fa-stack-overflow alt"
            target="_blank"
            ><span class="label">StackOverflow</span></a
          >
        </li>
      </ul>
    </section>
    <p class="copyright">&copy; {{ new Date().getFullYear() }} - A.Hatami</p>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>
